import { DateTime } from 'luxon';

export const today = () => {
  return DateTime.local()
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .minus({ millisecond: 1 });
};
